
import { defineComponent } from 'vue'
// import ClinicalSchedule from './ClinicalSchedule.vue'
import AppointmentQueues from './AppointmentQueues.vue'
import AppointmentBooking from './AppointmentBooking.vue'
import ClincalOverview from './ClincalOverview.vue'

export default defineComponent({
  name: 'PatientAppointments',
  components: {
    // ClinicalSchedule,
    ClincalOverview,
    AppointmentQueues,
    AppointmentBooking
  },
  data () {
    return {
      tab: null
    }
  }
})
// Types of Booking: Clinical, Surgical, Endoscopy Procedure, Intervention Procedure
